import { render, staticRenderFns } from "./StampCard.vue?vue&type=template&id=295852a0"
import script from "./StampCard.vue?vue&type=script&lang=js"
export * from "./StampCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports